"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.User = void 0;
var React = __importStar(require("react"));
var user_image_1 = require("../../components/entities/user-image");
var graphql_1 = require("../../utils/graphql");
var empty_date_calendar_1 = require("../../components/elements/empty-date-calendar");
exports.User = {
  name: 'User',
  label: 'Member',
  slug: 'member',
  table: {
    fieldNames: ["person", "roles", "invited", "profileCompletionDate", "lastLogin", "loginCount"],
    hideRemove: true,
    options: {
      roles: {
        weight: 2
      },
      invited: {
        type: 'relativeDate',
        weight: 0.8
      },
      profileCompletionDate: {
        title: 'Profile Completed',
        emptyContent: React.createElement(empty_date_calendar_1.EmptyDateCalendar, null),
        weight: 1.5,
        type: 'date',
        align: 'center'
      },
      lastLogin: {
        type: 'relativeDate'
      },
      loginCount: {
        type: 'count',
        weight: 1
      }
    }
  },
  orderByFields: ['person=name', 'invited', 'profileCompletionDate', 'lastLogin', 'loginCount'],
  components: {
    image: user_image_1.UserImage
  },
  list: {
    banner: {
      content: 'Manage the people who have access to the platform'
    },
    hasSearch: true,
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      profileCompletionDate\n      person { ...CreatorFields },\n    "], ["\n      profileCompletionDate\n      person { ...CreatorFields },\n    "]))),
    resultsVariant: "table"
  },
  create: {
    label: 'Add %s'
  },
  banner: {
    queryFields: "person { id slug name photo { id url } }"
  },
  useCreator: false,
  useOpenGraph: false,
  autoRoutes: ['list', 'create', 'update'],
  removeMessage: 'Are you sure you wish to remove %s from the platform? Note – this action is not reversible. <br><br>Removing this Member will <b>not</b> remove the associated Person profile from the platform, which needs to be removed separately.',
  form: {
    fieldSets: [{
      name: 'overview',
      intro: 'Grant login access to the platform for either a new or existing {{PERSON}}.'
    }],
    fields: {
      id: {
        type: 'id'
      },
      email: {
        type: 'email',
        required: true,
        focus: true,
        label: 'Email Address',
        description: 'Provide an active and valid email address for this account, which will be the username used when logging in.'
      },
      personId: {
        type: 'linked',
        required: true,
        aliasOf: 'person',
        entityTypeName: 'Person',
        label: 'Person Profile',
        description: 'Select or create a Person profile for this Member account. Member accounts and Person profiles are separated to allow a Person to still be listed in the platform (as a key stakeholder for example) while not necessarily having membersip via an account. Note – you cannot select people marked as MEMBER as they already have an account.',
        isOptionDisabled: function (context) {
          return function (option) {
            var person = context.entityData.personId || {
              id: ''
            };
            // @ts-ignore
            return option.entity && option.entity.hasAccount && person.id !== option.value;
          };
        }
      },
      site: {
        type: 'linked',
        entityTypeName: 'Site',
        label: 'Site',
        description: 'Select the site this user will be invited to (Optional). If not specified, this user will be invited to the platform instead.',
        isVisible: function (context) {
          return context.isCreate;
        }
      },
      roles: {
        type: 'linkedMultiple',
        required: true,
        label: 'Member Roles',
        entityTypeName: 'UserRole',
        description: 'Select one or more Member Roles for this account. Member Roles should be carefuly chosen as they precisely determine how much control a member has across the entire platform.'
      },
      isBlocked: {
        type: 'boolean',
        recommended: false,
        label: 'User Is Blocked?',
        description: 'Check this to block this member from accessing the platform.'
      }
    }
  },
  export: {
    fieldTypes: {
      isEmailVerified: 'boolean',
      lastLogin: 'datetime',
      invited: 'datetime'
    },
    queryFields: (0, graphql_1.graphql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      isEmailVerified\n      email\n      lastLogin\n      loginCount\n      invited\n      profileIsComplete\n      created\n      updated\n      person { slug name }\n      roles { name }\n      agreesToTerms\n\n    "], ["\n      isEmailVerified\n      email\n      lastLogin\n      loginCount\n      invited\n      profileIsComplete\n      created\n      updated\n      person { slug name }\n      roles { name }\n      agreesToTerms\n\n    "])))
  },
  update: {
    queryFields: "\n      email\n      isEmailVerified\n      isBlocked\n      personId: person { id name slug position isMember hasAccount organisation { id name slug location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } } } openGraph { id image { id url } } photo { id url thumbnails { id full { id url width height } } } location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } } }\n      roles { id name slug description }\n    "
  },
  filters: {
    fields: {
      roles: {
        entityTypeName: 'UserRole'
      },
      activityStatus: {
        type: 'select',
        label: 'Activity Status',
        placeholder: 'Any',
        options: [{
          label: "Active (has logged in)",
          value: "active"
        }, {
          label: "Inactive (has never logged in)",
          value: "inactive"
        }, {
          label: "Profile Incomplete",
          value: "incomplete"
        }]
      }
    }
  }
};
var templateObject_1, templateObject_2;